import { useTheme } from '@emotion/react';
import { Box, Typography, useMediaQuery } from '@mui/material';

const items = [
  {
    id: 1,
    year: '2016',
    title: 'Interne Entwicklungen in der IT Fabrik',
    description:
      'Schon vor acht Jahren begannen wir mit ersten internen Software-Projekten in der IT Fabrik. Die Anwendungen erleichterten vor allem interne Abläufe.',
  },
  {
    id: 2,
    year: '2021',
    title: 'Gründung der Codemeta GbR',
    description:
      'Für erste Kundenprojekte gründeten wir 2021 die Codemeta GbR. Unser Hauptprodukt: Die Tanss2weclapp-Schnittstelle.',
  },
  {
    id: 3,
    year: '2024',
    title: 'Das Team wächst - Umfirmierung in eine GmbH',
    description:
      'Mittlerweile umfasst unser Team sieben Entwickler, mit denen wir an unterschiedlichsten Projekten arbeiten.',
  },
];

export default function Who() {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#0E3B43',
        py: '120px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '80%',
          maxWidth: '1200px',
          [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
            gap: '35px',
          },
        }}
      >
        <Box
          sx={{
            width: '40%',
            [theme.breakpoints.down('lg')]: {
              width: '80%',
              display: 'flex',
              flexDirection: 'row',
            },
          }}
        >
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: '78px',
              fontWeight: '800',
              display: 'inline',
              lineHeight: '1.1',
              [theme.breakpoints.down('lg')]: {
                fontSize: '36px',
              },
            }}
          >
            Wer&nbsp;
          </Typography>

          <Typography
            sx={{
              color: '#fff',
              fontSize: '78px',
              fontWeight: '800',
              display: 'inline',
              lineHeight: '1.1',
              [theme.breakpoints.down('lg')]: {
                fontSize: '36px',
              },
            }}
          >
            sind{isMobileView ? ' ' : <br />}wir?
          </Typography>
        </Box>

        <Box
          sx={{
            width: '60%',
            [theme.breakpoints.down('lg')]: {
              width: '80%',
            },
          }}
        >
          {items.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                mb: '32px',
                [theme.breakpoints.down('lg')]: {
                  flexDirection: 'column-reverse',
                },
              }}
            >
              <Typography
                sx={{
                  color: 'primary.main',
                  fontSize: '48px',
                  textAlign: 'right',
                  fontWeight: '800',
                  width: '40%',
                  pr: '60px',
                  [theme.breakpoints.down('lg')]: {
                    width: '100%',
                    textAlign: 'left',
                  },
                }}
              >
                {item.year}
              </Typography>

              <Box
                sx={{
                  width: '60%',
                  [theme.breakpoints.down('lg')]: {
                    width: '100%',
                    textAlign: 'left',
                  },
                }}
              >
                <Typography
                  sx={{
                    color: '#fff',
                    fontSize: '24',
                    fontWeight: '600',
                    pt: '16px',
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: '#fff',
                    fontSize: '24',
                    pt: '4px',
                    fontWeight: '300',
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
